import { c as _c } from "react/compiler-runtime";
import { IconBugReport, Tooltip } from '@newfront-insurance/core-ui';
import type { JSX } from 'react';
import { ToolbarButton } from './toolbar-button';
const SERVICE_DESK_URL = 'https://newfront.atlassian.net/servicedesk/customer/portal/10/group/39/create/149';
interface ReportBugButtonProps {
  redirectUrl?: string;
}
export function ReportBugButton(t0) {
  const $ = _c(5);
  const {
    redirectUrl: t1
  } = t0;
  const redirectUrl = t1 === undefined ? SERVICE_DESK_URL : t1;
  let t2;
  if ($[0] !== redirectUrl) {
    t2 = () => window.open(redirectUrl, "_blank");
    $[0] = redirectUrl;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconBugReport className="dark:text-foreground" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <Tooltip message="Report a Bug" positionTip="bottom" offset="5px"><ToolbarButton tabIndex={0} title="Report a Bug" onClick={t2}>{t3}</ToolbarButton></Tooltip>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}